import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "@unizpay/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { setUnauthorizedHandler } from "./lib/api";
import { router } from "./router";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      // Client errors (4xx) won't succeed on retry; network/5xx errors get one more try.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 1,
    },
  },
});

// Any 401 means the session is gone: drop cached data and go to sign-in.
setUnauthorizedHandler(() => {
  if (window.location.pathname.startsWith("/login")) return;
  queryClient.clear();
  const back = window.location.pathname + window.location.search;
  void router.navigate(`/login?next=${encodeURIComponent(back)}`, { replace: true });
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
